export * from './autocomplete.service';
export * from './autocomplete.directive';
export * from './multiple.autocomplete.directive';

import {AutoComplete} from './autocomplete.directive';
import {MultipleAutocomplete} from './multiple.autocomplete.directive';

export const AUTO_COMPLETE_COMPONENTS = [
    AutoComplete,
    MultipleAutocomplete
];

export const AUTO_COMPLETE_PROVIDERS = [];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/autocomplete/index.ts